import { useDocumentStore } from '../../stores/documentStore';
import { truncateFilename } from '../../utils/fileUtils';
import './TabBar.css';

export function TabBar() {
  const { documents, activeDocumentId, setActiveDocument, removeDocument } = useDocumentStore();

  if (documents.length <= 1) return null;

  return (
    <div className="tabbar">
      <div className="tabbar-scroll">
        {documents.map((doc) => (
          <div
            key={doc.id}
            className={`tab ${doc.id === activeDocumentId ? 'active' : ''}`}
            onClick={() => setActiveDocument(doc.id)}
          >
            <span className="tab-icon">📄</span>
            <span className="tab-label" title={doc.filename}>
              {truncateFilename(doc.filename, 20)}
            </span>
            {!doc.isSaved && <span className="tab-unsaved">●</span>}
            <button
              className="tab-close"
              onClick={(e) => {
                e.stopPropagation();
                removeDocument(doc.id);
              }}
              title="Close"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
